export default "<div class=\"cds-inline-note-title\">{{title}}</div>\r\n<div class=\"cds-inline-note-text\"[innerHTML]=\"message\"></div>\r\n"